export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00022.dd824e0b.png";